module.exports = __webpack_public_path__ + "media/images/amenities_icons/kitchen-1364749d4fce73eb3262543a07cd9a44.svg";